// src/pages/RelatorioICV.jsx
import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import GraficoPerfilICV from './GraficoPerfilICV';
import interpretacaoICV from '../utils/interpretacaoICV';
import { NOMES_FATORES } from '../utils/tabelaConversaoICV';
import calcularResultadosICV from '../utils/calcularResultadosICV';

export default function RelatorioICV() {
  const { state } = useLocation();
  const navigate = useNavigate();

  if (!state) {
    return (
      <div style={{ padding: 32 }}>
        <h2>Relatório não encontrado</h2>
        <button onClick={() => navigate('/')}>Voltar</button>
      </div>
    );
  }

  // Se vieram PTs prontos, usa; senão calcula a partir das respostas.
  let ptResultados = state.ptResultados;
  let brutos = state.brutos;

  if (!ptResultados) {
    const { brutos: b, pts: p } = calcularResultadosICV(state.respostas || {});
    brutos = b;
    ptResultados = p;
  }

  const ordem = ['DGV','R','A','I','II','III','IV','V','VI','VII','VIII','IX'];

  const blocos = ordem.map((fator) => {
    const pt = Number(ptResultados?.[fator] ?? 0);
    const bruto = Number(brutos?.[fator] ?? 0);

    // classificação textual pela escala PT
    const faixaKey =
      pt <= 1 ? 'muito_baixo' :
      pt <= 4 ? 'baixo' :
      pt <= 6 ? 'medio' :
      pt <= 8 ? 'acima_media' : 'alto';

    const faixaRotulo =
      faixaKey === 'muito_baixo' ? 'muito baixo' :
      faixaKey === 'baixo' ? 'baixo' :
      faixaKey === 'medio' ? 'médio' :
      faixaKey === 'acima_media' ? 'acima da média' : 'alto';

    // texto técnico
    const texto = (interpretacaoICV[fator] || {})[faixaKey] || '';

    return { fator, nome: NOMES_FATORES[fator] || fator, pt, bruto, faixaRotulo, texto };
  });

  return (
    <div style={{ maxWidth: 920, margin: '2rem auto', background: '#fff', borderRadius: 12, padding: 32, boxShadow: '0 2px 16px rgba(36,47,60,0.08)' }}>
      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center' }}>
        <h2 style={{ fontWeight:800, fontSize:28 }}>Relatório Técnico do ICV</h2>
        <div style={{ display:'flex', gap:8, flexWrap:'wrap' }}>
          <button className="no-print" style={{ padding:'10px 18px', borderRadius:7, border:'1px solid #e3e7ee', background:'#f7f9fc', cursor:'pointer' }} onClick={() => navigate(-1)}>Voltar</button>
          <button className="no-print" style={{ padding:'10px 18px', borderRadius:7, border:'none', background:'#242F3C', color:'#fff', fontWeight:700, cursor:'pointer' }} onClick={() => window.print()}>Imprimir</button>
        </div>
      </div>

      <div style={{ margin:'16px 0 24px' }}>
        <GraficoPerfilICV ptResultados={Object.fromEntries(ordem.map(k => [k, ptResultados[k] || 0]))} />
      </div>

      <div style={{ color:'#333', lineHeight:1.7, marginTop:8 }}>
        {blocos.map(({ fator, nome, pt, bruto, faixaRotulo, texto }) => (
          <div key={fator} style={{ marginBottom:22, paddingBottom:18, borderBottom:'1px solid #eee' }}>
            <strong style={{ fontSize:19 }}>
              {fator} — {nome}
              <span style={{ color:'#888', fontSize:14, fontWeight:400 }}>
                {' '}({faixaRotulo}, PT = {pt}, bruto = {bruto})
              </span>
            </strong>
            <div style={{ marginTop:7 }}>{texto}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
